export default "__VITE_ASSET__Cvf06FTl__"